import { useContext, useEffect, useState } from "react";
import WorkFlowModal from "./WorkFlowModal";
import { appRequest } from "routes";
import { AppContext } from "AppProvider/AppContext";
import WorkFlowFormModal from "../WorkFlowFormModal/WorkFlowFormModal";
import { generateEditInitialValues, transformFields } from "./utils/function";
import { replaceLabelValueObjects } from "utils/functions/function";

const EditForm = ({ isOpen, setIsOpen, initialValues, handleGetData }: any) => {
  const { toastNotify, getDefaultWorkFlow, workFlowData, getUsersWorkFlows } =
    useContext(AppContext);
  const [deletedApprovals, setDeletedApproavals] = useState<any>([]);
  const [loading, setLoading] = useState(false);
  const [showError, setShowError] = useState(false);

  const submitForm = async (valuess: any, resetForm: any) => {
    try {

      let obj: any = {
        deletedApprovals: deletedApprovals,
        values: {
          ...replaceLabelValueObjects(valuess),
          approvals: valuess.approvals,
          bulkApproveApproval: valuess.bulkApproveApproval,
          bulkRejectApproval: valuess.bulkRejectApproval,
          canAdditionalDocument: valuess.canAdditionalDocument,
          updateFirstUserNotification: valuess.updateFirstUserNotification,
          differentiateFirstLevel: valuess.differentiateFirstLevel,
          reset_to_level_1: valuess.reset_to_level_1,
          onboarding: valuess.onboarding,
          isPDF: valuess.isPDF,
          isWord: valuess.isWord,
          showUploadTab: valuess.showUploadTab,
          dateFilter: valuess.dateFilter,
          fileViewer: valuess.fileViewer,
          filters: valuess.filters,
          logo: valuess.logo,
          triggers: valuess.triggers,
          workFlowName: valuess.workFlowName,
          identifier: valuess.identifier,
          levels: valuess.levels,
          sortBy: valuess.sortBy,
          searchFilter: valuess.searchFilter,
          table: valuess.table,
          tab: valuess.tab,
          documentType: valuess.documentType,
          notification: valuess.notification,
          schema: valuess.schema,
          regions: valuess.regions?.value || (Array.isArray(valuess.regions) ? valuess.regions[0] : valuess.regions) || valuess.regions,
          // withdrawalApproval:valuess.withdrawalApproval || [],
          // withdrawalLevel:valuess.withdrawalLevel || [],
          // showAdditionalForm : Array.isArray(valuess.showAdditionalForm) ? valuess.showAdditionalForm?.map((it : any) => it.value) : [],
          // fieldsToDisable : Array.isArray(valuess.fieldsToDisable) ? valuess.fieldsToDisable : [],
        },
        workFlowName: valuess.workFlowName,
        flowName: valuess.flowName,
        processName: valuess.processName?.value || valuess.processName,
        processType: valuess.processType?.value || valuess.processType,
        levels: valuess.levels,
        identifier: valuess.identifier,
        id: initialValues._id,
        regions: valuess.regions?.value || (Array.isArray(valuess.regions) ? valuess.regions[0] : valuess.regions) || valuess.regions,
      };
      setLoading(true);
      if (valuess) {
        const response: any = await appRequest("workflow", "update", obj);
        if (response.status === "success") {
          toastNotify({
            title: `Workflow Created successfully`,
            message: response.message || "Something went wrong.",
            type: "success",
          });
          handleGetData();
          resetForm();
          handleCloseModal();
          if (valuess._id === workFlowData?._id) {
            getDefaultWorkFlow();
            getUsersWorkFlows();
          }
        } else {
          toastNotify({
            title: `Error getting the workflow.`,
            message: response.message || "Something went wrong.",
            type: "error",
          });
        }
      }
    } catch (err: any) {
      console.log(err)
      toastNotify({
        title: `Error getting the workflow.`,
        message: err.message || "Something went wrong.",
        type: "error",
      });
    } finally {
      setLoading(false);
    }
  };

  const handleCloseModal = () => {
    setIsOpen(false);
    setLoading(false);
  };

  return (
    <>
      <WorkFlowFormModal
        setDeletedApproavals={setDeletedApproavals}
        type="edit"
        isOpen={isOpen}
        onClose={handleCloseModal}
        initialValues={generateEditInitialValues(
          {
            ...initialValues,
            ...initialValues.values
          },
          transformFields(initialValues?.schema?.fields || [])
        )}
        loading={loading}
        submitForm={submitForm}
        showError={showError}
        setShowError={setShowError}
      />
    </>
  );
};

export default EditForm;
